import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LifeBuoy } from 'lucide-react'
import { HelpCentreScreen } from '@/screens/help/SCR-175-help-centre'

// SCR-175 Help centre (help area).
export const Route = createFileRoute('/_app/help/')({
  staticData: { screen: { id: 'SCR-175', title: 'Help centre', group: 'Help', pin: true, order: 1, description: 'Answers to common questions, step-by-step guides and ways to reach us.', icon: LifeBuoy } },
  validateSearch: z.object({
    q: z.string().max(200).optional().catch(undefined),
    section: z.string().max(40).optional().catch(undefined),
    article: z.string().max(120).regex(/^[a-z0-9-]+$/).optional().catch(undefined),
    /** Contextual help: the screen id or console path the person came from. */
    screen: z.string().max(300).optional().catch(undefined),
  }),
  component: HelpCentreScreen,
})
